export default __webpack_public_path__ + "img/f311f4e2f5b55bb4c03335e3bccc8b66.png";